export function getdata() {
	let obj = {
		headData: [{
			title: '任务名称',
			prop: 'taskName',
			width: '220',
			issort: true,
		}, {
			title: '任务批次号',
			prop: 'batchNo',
			width: '220',
			issort: true,
		}, {
			title: '执行时间',
			prop: 'executeTime',
			width: '220',
			issort: true,
		}, {
			title: '任务完成时间',
			prop: 'completeTime',
			width: '220',
			issort: true,
		}, 
		// {
		// 	title: '当前任务进度',
		// 	prop: 'tes5',
		// 	width: '220',
		// 	issort: true,
		// 	custom: true,
		// }, 
		{
			title: '处理状态',
			prop: 'status',
			width: '220',
			showFilter: true,
			custom: true,
			checkList: ['-1', '0', '1'],
			dataList: [{
					name: "失败",
					code: "-1"
				},
				{
					name: "任务处理中",
					code: "0"
				},
				{
					name: "任务完成",
					code: "1"
				},
			]
		}, {
			title: '错误原因',
			prop: 'errorMessage',
			width: '220',
			issort: true,
		}, ],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
